import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  delivery_manager_fullname: string;
};
const DeliveryManagerCell = React.memo((row: KpiWorkunitGridData) => (
  <>
    {row?.delivery_manager_fullname && (
      <Tooltip title={row?.delivery_manager_fullname}>
        <Typography variant="body2" noWrap>
          {row?.delivery_manager_fullname}
        </Typography>
      </Tooltip>
    )}
  </>
));

export default DeliveryManagerCell;
